import { ApiProperty } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { JobDto } from '../../job/dto/job.dto';
import { JobPhaseRequestResourceBatchErrorInterface } from '../interfaces/job-phase-request-resource-batch-error.interface';

@Exclude()
export class JobPhaseRequestResourceBatchErrorDto
  implements JobPhaseRequestResourceBatchErrorInterface
{
  @ApiProperty({
    title: 'Job',
    description: 'Job',
  })
  @Expose()
  job!: JobDto;

  @ApiProperty({
    title: 'Error Message',
    description: 'Error Message',
  })
  @Expose()
  errorMessage!: string;
}
